import { db } from "../firebase-config";
import { collection, deleteDoc, query, addDoc, onSnapshot, doc } from "firebase/firestore";

export const customerNoteSnapshotListener = (organization, customerId, onNoteUpdate) => {
    const customerNoteQuery = query(collection(db, "organizations", organization, "customers", customerId, "notes"))
    const unsubscribe = onSnapshot(customerNoteQuery, (querySnapshot) => {
        const noteItems = [];
        querySnapshot.forEach((doc) => {
          noteItems.push({ id: doc.id, ...doc.data() });
        });
        onNoteUpdate(noteItems);
    })
    return () => unsubscribe()
}

export const addClientNote = async (organization, clientId, note) => {
    try {
        await addDoc(collection(db, "organizations", organization, "customers", clientId, "notes"), note);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error adding client note:", error);
        return { success: false, error: error.message || 'Failed to add client note' };
    }
};

export const deleteCustomerNote = async (organization, customerId, noteId) => {
    try {
        const noteRef = doc(db, "organizations", organization, "customers", customerId, "notes", noteId);
        await deleteDoc(noteRef);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting note:", error);
        return { success: false, error: error.message || 'Failed to delete note' };
    }
};

export const addAssetNote = async (organization, assetId, note) => {
    try {
        await addDoc(collection(db, "organizations", organization, "assets", assetId, "notes"), {
            title: note.title,
            content: note.content,
            date: note.date
        });
        return { success: true, error: null };
    } catch (error) {
        console.error(`Failed to add note: ${note.title}`, error);
        return { success: false, error: error.message || 'Failed to add note.' };
    }
};

export const deleteAssetNote = async (organization, assetId, noteId) => {
    try {
        await deleteDoc(doc(db, "organizations", organization, "assets", assetId, "notes", noteId));
        return { success: true, error: null };
    } catch (error) {
        console.error(`Failed to delete note with ID: ${noteId}`, error);
        return { success: false, error: error.message || 'Failed to delete note.' };
    }
};